module.exports = __webpack_public_path__ + "static/media/Druid_Balance.df276bf5.png";